import styled, {keyframes} from 'styled-components';
import React from 'react';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SpinnerAnimation = styled.div`
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation: ${rotate360} 1.1s infinite linear;
  border-radius: 50%;
  ${({theme, variation, size}) => {
    let primaryColor;
    let secondaryColor;
    switch (variation) {
      case 0:
      case 1:
      case 3:
      case 4:
      case 5:
      case 6:
        primaryColor = theme.primaryColor;
        secondaryColor = `rgba(255, 255, 255, 0.8)`;
        break;
      case 2:
        primaryColor = theme.accentColor;
        secondaryColor = `rgba(255, 255, 255, 0.8)`;
        break;
    }
    let spinnerSize;
    let spinnerThickness;
    if (size === 'S') {
      spinnerSize = 14;
      spinnerThickness = 1;
    } else {
      spinnerSize = 25;
      spinnerThickness = 3;
    }
    return `
      height: ${spinnerSize}px;
      width: ${spinnerSize}px;
      border-left: ${spinnerThickness}px solid ${primaryColor};
      border-top: ${spinnerThickness}px solid ${secondaryColor};
      border-right: ${spinnerThickness}px solid ${secondaryColor};
      border-bottom: ${spinnerThickness}px solid ${secondaryColor};
      &:after {
        border-radius: 50%;
        height: ${spinnerSize}px;
        width: ${spinnerSize}px;
      }
    `;
  }}
`;
const SpinnerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
const Spinner = props => {
  return (
    <SpinnerContainer>
      <SpinnerAnimation {...props}/>
    </SpinnerContainer>
  );
};
export default Spinner;